import { useState } from "react";
import { Link } from "react-router-dom";
import { Droplets, Menu, Phone, X } from "lucide-react";
import { PHONE } from "./shared";

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);
  return (
    <header className="site-head">
      <nav className="nav container">
        <a data-testid="brand-home-link" className="brand" href="/#home" onClick={close}><span className="brand-mark"><Droplets size={19}/></span><span className="brand-word">Parth <b>Enterprises</b><small>Sales & Service — Raipur</small></span></a>
        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <a data-testid="nav-home-link" href="/#home" onClick={close}>Home</a>
          <a data-testid="nav-services-link" href="/#services" onClick={close}>Services</a>
          <a data-testid="nav-about-link" href="/#why-us" onClick={close}>Why us</a>
          <a data-testid="nav-areas-link" href="/#areas" onClick={close}>Areas</a>
          <a data-testid="nav-testimonials-link" href="/#testimonials" onClick={close}>Testimonials</a>
          <a data-testid="nav-contact-link" href="/#contact" onClick={close}>Contact</a>
          <Link data-testid="nav-blog-link" to="/blog" onClick={close}>Blog</Link>
        </div>
        <div className="nav-side">
          <a data-testid="nav-call-button" className="nav-call" href={`tel:${PHONE}`}><Phone size={15}/> Call Now</a>
          <button data-testid="mobile-menu-button" className="mobile-menu" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">{menuOpen ? <X/> : <Menu/>}</button>
        </div>
      </nav>
    </header>
  );
}
